import { common } from '@kurtosys/ksys-app-template';

import { IDatePickerDateAdapter } from './models/IDateAdapter.js';

const isoAdapter: IDatePickerDateAdapter = { parse: common.commonUtils.parseISODate, format: common.commonUtils.printISODate };
export default isoAdapter;
